
import CollectionDisplayItem from './CollectionDisplayItem.vue';
import CollectionDisplayList from './CollectionDisplayList.vue';
import IconTooltipContent from './IconTooltipContent.vue';
import IconBrand from '~/components/icons/IconBrand.vue';
import IconDeliver from '~/components/icons/IconDeliver.vue';
import IconMake from '~/components/icons/IconMake.vue';
import IconPlan from '~/components/icons/IconPlan.vue';
import IconSource from '~/components/icons/IconSource.vue';
import IconStore from '~/components/icons/IconStore.vue';
import Tooltip from '~/components/generic/Tooltip.vue';
import IconMakeActive from '~/components/icons/IconMakeActive.vue';
import IconSourceActive from '~/components/icons/IconSourceActive.vue';
import IconPlanActive from '~/components/icons/IconPlanActive.vue';
import IconBrandActive from '~/components/icons/IconBrandActive.vue';
import IconStoreActive from '~/components/icons/IconStoreActive.vue';
import IconDeliverActive from '~/components/icons/IconDeliverActive.vue';
import CollectionDisplayItemBig from '~/components/page-components/collectionpage/CollectionDisplayItemBig.vue';
import IconArrowRightSmall from '~/components/icons/IconArrowRightSmall.vue';

export default {
  components: { IconPlan, IconMake, IconSource, IconBrand, IconDeliver, IconStore, CollectionDisplayList, CollectionDisplayItem, CollectionDisplayItemBig, Tooltip, IconTooltipContent, IconPlanActive, IconBrandActive, IconStoreActive, IconDeliverActive, IconMakeActive, IconSourceActive, IconArrowRightSmall }

};
